export default __webpack_public_path__ + "static/media/new-gogreen-page-banner-radio-rentals.9b0793f6.jpg";